import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class AdministrativeMappingService {

  constructor(private dataService: DataService) { }

  getUserMapping(financialYear: number, refresh: boolean = true) {
    return this.dataService.getData(`/api/administrativeMapping/user-mapping/${financialYear}`, refresh);
  }

  getRegions(financialYear: number, refresh: boolean = true) {
    return this.dataService.getData(`/api/administrativeMapping/regions/${financialYear}`, refresh);
  }

  getDivisions(regionId: number, financialYear: number, refresh: boolean = true) {
    return this.dataService.getData(`/api/administrativeMapping/divisions/${regionId}/${financialYear}`, refresh);
  }

  getSubDivisions(divisionId: number, financialYear: number, refresh: boolean = true) {
    return this.dataService.getData(`/api/administrativeMapping/subdivisions/${divisionId}/${financialYear}`, refresh);
  }
}
